"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var currentTeamSettingsReducer_1 = __importDefault(require("./currentTeamSettingsReducer"));
var currentTeamReducer = function (state, action) {
    if (action.type === 'ROUTE_CHANGE') {
        // eslint-disable-next-line no-param-reassign
        state = undefined;
    }
    return (0, toolkit_1.combineReducers)({
        settings: currentTeamSettingsReducer_1.default,
    })(state, action);
};
exports.default = currentTeamReducer;
